import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { togglePassengerExpanded } from 'store/actions';
import { fromReservation } from 'store/selectors';

import { GuestListEntryContent } from 'components';

const GuestListEntryContentContainer = props => <GuestListEntryContent {...props} />;

const mapStateToProps = (state, { id }) => ({
  visaRequired: fromReservation.getVisaRequiredForGuest(state, id),
  collectPassportInfo: fromReservation.collectPassportInfo(state, id),
  collectIcePhoneNumber: fromReservation.collectIcePhoneNumber(state, id),
  collectLoyaltyNumber: fromReservation.collectLoyaltyNumber(state, id),
  invalidPassportFields: fromReservation.getMissingPassportFields(state, id),
  requiredFieldsFilled: fromReservation.isGuestsRequiredFieldsFilled(state, id),
});

const mapDispatchToProps = (dispatch, { id }) => ({
  onToggleExpanded: () => dispatch(togglePassengerExpanded(id)),
});

GuestListEntryContentContainer.propTypes = {
  id: PropTypes.string.isRequired,
};

export default connect(mapStateToProps, mapDispatchToProps)(GuestListEntryContentContainer);



// WEBPACK FOOTER //
// ./src/containers/GuestListEntryContent.js